<div class="empty-numbers-wrapper">
  <div class="empty-numbers-header" translate>ORDER_NUMBER.NO_NUMBERS</div>
  <div class="empty-numbers-description" translate>ORDER_NUMBER.CHOOSE_DIFFERENT_CITY</div>
  <button
    mat-raised-button
    (click)="back()"
    color="primary-full">
    <span translate>ORDER_NUMBER.BACK_TO_THE_LIST</span>
  </button>
</div>
